export default {
  header: {
    index: '首页',
    hotel: '酒店',
    ticket: '门票',
    tour: '线路',
    user: '用户',
    yl: '邮轮',
    gntp: '套票'
  },
  tplist: {
    sstp: '搜索套票',
    zdzh: '找到最适合您的旅行套餐',
    qsrt: '请输入套票名称搜索',
    ydrq: '预定日期',
    xzqy: '选择区域',
    ss: '搜索',
    jxtp: '精选套票',
    fxzs: '发现最受欢迎的旅行体验',
    ckxq: '查看详情',
    rmmd: '热门目的地',
    sscf: '随时出发',
    q: '起',
    ljyd: '立即预订',
    zwtp: '暂无套票数据',
    zsmy: '暂时没有找到符合条件的套票，请尝试调整搜索条件',
    cxjz: '重新加载',
    hk: '香港',
    am: '澳门',
    dl: '大陆',
    tw: '台湾',
    hw: '海外',
    loading: '加载中...',
    loadFailed: '图片加载失败'
  },
  tpdetail: {
    xzfj: '选择附加产品',
    tpne: '套票内容与说明',
    zkqb: '展开全部',
    qb: '全部',
    fybh: '费用包含',
    dqrq: '当前日期不可预订',
    grqz: '该日期暂无可预订的产品',
    xzrq: '选择日期',
    ytdg: '一同訂購更多體驗, 包括觀光桌、門票、交通接駁等!',
    txgd: '挑选更多玩乐体验',
    qcsy: '清除所有',
    crzw: '此日暂无价格',
    zwjg: '暂无价格',
    tpje: '套票金额补差',
    jd: '酒店',
    bkd: '不可定',
    ddyd: '单独预订价格',
    xj: '星级',
    fx: '房型',
    jdss: '酒店设施',
    rssx: '人数上限',
    zd: '最多',
    r: '人',
    d: '大',
    x: '小',
    mp: '门票',
    ydxz: '预定须知',
    cpxq: '产品详情',
    cq: '餐券',
    bc: '包车',
    dy: '行程',
    qtcp: '其他产品',
    fhcp: '返回产品列表',
    zzjs: '正在计算价格...',
    zzjz: '正在加载价格，请稍候...',
    gcpw: '个产品未完成选择',
    hy: '还有',
    qx: '取消',
    jdzs: '酒店住宿',
    jdmc: '酒店名称',
    fxmc: '房型名称',
    h: '含',
    fzc: '份早餐',
    bhz: '不含早',
    j: '间',
    w: '晚',
    syrq: '使用日期',
    sl: '数量',
    fjcp: '附加产品',
    hjzj: '合计总金额',
    xyb: '下一步 立即预定',
    tpsl: '套票数量',
    gqsh: '正在计算价格，请稍候...',
    tpyd: '套票预定须知',
    zdl: '知道了',
    cqmp: '餐券/门票',
    fxtc: '非系统产品',
    tpxq: '套票详情',
    gxx: '个选项',
    qf: '份',
    qd: '确定',
    jzz: '加载中...',
    qdsc: '确定要删除这个附加产品吗？',
    qdqc: '确定要清除所有附加产品吗？',
    crzj: '此日暂无价格',
    zj: '暂无价格',
    crzjqxtrq: '此日暂无价格,请选择其他日期',
    tpnrzjqxtrq: '套票内容暂无价格，请选择其他日期',
    crzjqxtrq2: '此日暂无价格，请选择其他日期',
    tpnrzjqxtrq2: '套票内容暂无价格，请选择其他日期',
    tpnrzjwbyd: '套票内容暂无价格，无法预订',
    zjqkzql: '暂无价格，数量已自动清零',
    crzjqkzql: '此日暂无价格请重新选择',
    z: '张',
    // 早餐信息翻译
    noBreakfast: '不含早',
    breakfast1: '含1份早',
    breakfast2: '含2份早',
    breakfastCount: '含{count}份早',

    // 错误提示信息
    completeAddOnSettings: '请完成附加产品设置或点击"清除所有"移除未完成的附加产品',
    hotelNotAvailable: '酒店部分不可定',
    ticketNotAvailable: '门票部分不可定',
    packageNotAvailable: '套票当前日期不可定',
    bookingConditionsNotMet: '预订条件不满足，请检查选择的内容',
    bookingConditionsNotMetNoJump: '预订条件不满足，无法跳转',
    productUnavailableForDate: '此日产品暂不可定',
    productUnavailableForDateMessage: '此日产品暂不可定，请选择其他日期'
  },
  tporder: {
    tpne: '套票名称',
    zkqb: '预订数量',
    fybh: '使用日期',
    dqrq: '价格详情',
    grqz: '套票数量',
    xzrq: '收起套票包含内容',
    wlbh: '查看套票包含内容',
    txgd: '酒店住宿',
    qcsy: '门票景点',
    crzw: '数量',
    zwjg: '其他产品',
    tpje: '人数补差价格',
    jd: '收起附加产品',
    ckfj: '查看附加产品',
    ddyd: '附加产品',
    zxzf: '在线支付',
    fj: '新增游客',
    jdss: '游客',
    rssx: '姓氏',
    zd: '请输入姓氏',
    r: '张',
    d: '名字',
    x: '请输入名字',
    mp: '性别',
    bkd: '请选择性别',
    ydxz: '预定须知',
    cpxq: '产品详情',
    z: '我们会传递您的要求，但不保证能满足',
    cq: '附加信息',
    bc: '预定须知',
    qtcp: '此产品需要二次确认!',
    fhcp: '暂无详细信息',
    qf: '关闭',
    zzjs: '至少需要保留1名游客',
    xj: '暂无预定须知信息',
    zzjz: '暂无产品详情信息',
    tpmc: '套票名称',
    ydsl: '预订数量',
    syrq: '使用日期',
    jgxq: '价格详情',
    tpsl: '套票数量',
    jdzs: '酒店住宿',
    mpjd: '门票景点',
    qtcp2: '其他产品',
    rscb: '人数补差价格',
    fjcp: '附加产品',
    zxzf2: '在线支付',
    xzyk: '新增游客',
    yk: '游客',
    xs: '姓氏',
    qsrxs: '请输入姓氏',
    mz: '名字',
    qsrmz: '请输入名字',
    xb: '性别',
    qxzxb: '请选择性别',
    n: '男',
    nv: '女',
    bzxx: '备注信息',
    fhcp2: '返回产品列表',
    gb: '关闭',
    zdyk: '至少需要保留1名游客',
    zwydxz: '暂无预定须知信息',
    zwcpxq: '暂无产品详情信息',
    tpxq: '套票详情',
    ydxz2: '预定须知',
    cpxq2: '产品详情',
    hj: '合计'
  },
  gntp: {
    sycp: '所有产品',
    mpjd: '门票景点',
    jdtp: '酒店套票',
    ddms: '当地美食',
    ddhqc: '当地好去处',
    splb: '商品类别',
    dq: '地区',
    gjz: '关键字',
    ss: '搜索',
    hpl: '好评率',
    ydts: '预定提示',
    xzcp: '选择产品',
    ecqr: '产品由合作伙伴提供，预定后需二次确认。',
    jjqg: '立即抢购',
    cpjs: '产品介绍',
    jtxl: '交通线路',
    cpfl: '产品分类',
    mdd: '目的地'

  },
  util: {
    Agreement: '分销申请协议',
    ljcz: '立即重置',
    yzm: '验证码',
    fsyzm: '发送验证码',
    qsryzm: '请输入验证码',
    yyzh: '已有账号，登录',
    ljzc: '立即注册',
    jrwm: '加入HUAYI',
    zdj: '最低价',
    q: '起',
    jrck: '进入查看',
    cfd: '出发地',
    cfrq: '出发日期',
    xcts: '行程天数',
    mddgjz: '目的地/关键字',
    mdd: '目的地',
    rzrq: '入住日期',
    w: '晚',
    ldrq: '离店日期',
    fjzks: '房间&住客数',
    fjs: '房间数',
    crs: '成人数',
    ets: '儿童数',
    qd: '确定',
    j: '间',
    cr: '成人',
    xt: '小童',
    ss: '搜索',
    jdxj: '酒店星级',
    ywrq: '游玩日期',
    z: '周',
    pjmwbhsj: '平均每晚不含税价',
    drysw: '当日已售完',
    ck: '查看',
    dg: '订购',
    dz: '地址',
    bz: '币种',
    zhyb: '最后一步',
    ydxq: '预订详情',
    yxjd: '已选酒店',
    yxcp: '已选产品',
    llwm: '联络我们',
    bqsy: '版权所有',
    yysjyw: '营业时间以外请致电',
    yysj: '营业时间',
    rjkfdh: '日间客服电话',
    khfwzy: '客户服务支援',
    lxwm: '联系我们',
    mee: 'MEE美意 APP',
    gywm: '关于我们',
    zzjzgd: '正在加载更多中',
    wsydx: '我是有底线的',
    htgdsfzhdr: '或通过第三方帐户登入',
    wjmm: '忘记密码',
    myzh: '没有账号?立即注册',
    ljdl: '立即登录',
    ystk: '隐私条款',
    tkxz: '条款及细则',
    khdl: '客户登录',
    thdl: '同行登录',
    yhm: '用户名',
    yhmdesc: '请输入用户名',
    mm: '密码',
    mmdesc: '请输入密码',
    ty: '同意',
    qxtytkxz: '请先同意条款及细则',
    wddd: '我的订单',
    tcdl: '退出登录',
    drhqhyzg: '登入以获取会员价格',
    drhzc: '登入或注册',
    ydjc: '预定检测',
    qxdl: '请先登录',
    gxn: '恭喜您，您已选择最优价格产品',
    hyh: '很遗憾，当前产品暂不可订'
  },
  index: {
    slogan: '千里之行 始于华逸',
    jdyd: '酒店预订',
    djtp: '度假套票',
    mscj: '美食餐券',
    jdmp: '景点门票',
    gty: '跟团游',
    hwsdy: '户外深度游',
    hwly: '户外露营',
    wqdj: '温泉度假',
    appTitle: '旅行 ． 从此简单',
    appDesc: '随时随地，只需几秒，即可轻松预订机票、酒店、火车票及租车。',
    hzhb: '合作伙伴',
    hzhbdesc: 'HUAYI TRAVEL 携手各领域合作伙伴，为您提供最完善的旅游体验',
    jdtj: '酒店推介',
    zwcp: '暂无产品',
    cjtj: '餐券推介',
    ddwl: '当地玩乐推介',
    rmxc: '热门行程',
    rm: '热门',
    gat: '港澳台',
    gn: '国内',
    dny: '东南亚',
    az: '澳洲',
    oz: '欧洲',
    tp: '套票',
    xg: '香港',
    am: '澳门',
    zyx: '自由行',
    xl: '线路',
    rb: '日本',
    jd: '酒店'
  },
  cruise: {
    yl: '游轮',
    bz: '种类',
    bh: '编号',
    mc: '名称',
    xc: '行程',
    cfrq: '出发日期',
    ljbl: '立即办理'
  },
  hotel: {
    bhs: '本优惠价未含发票等税费（如有）',
    Sun: '日',
    Mon: '一',
    Tus: '二',
    Wes: '三',
    Thur: '四',
    Fri: '五',
    Sat: '六',
    jjd: '家酒店',
    gzd: '共找到',
    yfdsjbdpf: '因酒店售价波动频繁，实际应付金额以订单成立后为准',
    pjmwhsj: '平均每晚含税价',
    exj: '二星及以下/经济',
    snxj: '三星/舒适',
    sxj: '四星/高级',
    wxj: '五星/豪华',
    xj: '星级',
    ljqr: '立即确认',
    tp: '套票',
    hzc: '含早餐',
    rmsx: '热门筛选',
    xsdt: '显示地图',
    ss: '搜索',
    et: '儿童',
    cr: '成人',
    qd: '确定',
    ets: '儿童数',
    crs: '成人数',
    fjs: '房间数',
    fjsjrs: '房间数及人数',
    w: '晚',
    ldrq: '离店日期',
    rzrq: '入住日期',
    mdd: '目的地/关键字',
    zwcxdfx: '暂无查询到房型',
    zyzx: '重要资讯',
    jqld: '景区亮点',
    jdjs: '酒店介绍',
    z: '张',
    hj: '合计',
    wzc: '位早餐',
    h: '含',
    bhz: '不含早',
    gxsjh: '个销售计划',
    zsew: '展示额外',
    yc: '隐藏',
    yd: '预定',
    bhsjfwf: '不含税及服务费',
    xsyh: '限时优惠',
    bnqx: '不能取消',
    gatzx: '港澳台专享',
    ydts: '预定提示',
    pjmfmwjg: '平均每房每晚价格',
    xgzc: '相关政策',
    mc: '名称',
    zxzf: '在线支付',
    j: '间',
    jgxq: '价格详情',
    fh: '返回',
    tjcddjbsnyydbty: '提交此订单即表示您已阅读并同意 huayitraveltd.com 之使用细则与私隐条款。',
    xybzhqr: '下一步：最后确认',
    czsjjzdnl: '此住宿将尽最大努力，但不能保证可满足所有要求。',
    xt: '（选填）',
    tsyq: '特殊要求',
    dl: '大陆86',
    am: '澳门853',
    xg: '香港852',
    jyykhfw: '仅用于客户服务',
    qsrzqdhhm: '请输入正确电话号码',
    dhhm: '电话号码',
    yyjsqryj: '用于接收确认邮件',
    qsrzqyxdz: '请输入正确邮箱地址',
    qsryxdz: '请输入邮箱地址',
    dy: '电邮',
    gajdqtyw: '港澳海外酒店请填写英文或拼音',
    mzdesc: '请输入名字',
    mz: '名字',
    xsdesc: '请输入姓氏',
    xs: '姓氏',
    xzzk: '新增住客(可选)',
    fj: '房间',
    rkzldesc: '住客姓名必须与登记入住时使用之有效证件完全一致。',
    zkzl: '住客资料',
    gmsl: '购买数量',
    dj: '单价',
    fjcp: '附加产品',
    tyd: '天预定',
    xtq: '需提前',
    rzts: '入住天数',
    zao: '早',
    zcsl: '早餐数量',
    etnl: '儿童年龄',
    mfjrzet: '每房间入住儿童',
    mfjrzcr: '每房间入住成人',
    mfjzdrz: '每房间最大入住',
    fx: '房型',
    xsjh: '销售计划',
    dz: '地址',
    qsrdhhm: '请输入电话号码',
    ts: '提示',
    djrl: '低价日历(当日最低价)',
    tf: '入住和退房时间均为酒店当地时间.',
    bz: '币种',
    night: '晚',
    Year: '年',
    Month: '月',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    seven: '日',
    day: '日',
    ROO: '每房'

  },
  tour: {
    qrww: '确定无误',
    qx: '取 消',
    tkzc: '条款政策',
    zj: '证件',
    csrq: '出生日期',
    xb: '性别',
    yx: '邮箱',
    dh: '电话',
    xm: '姓名',
    bc: '补差',
    ye: '婴儿',
    etbzc: '儿童不占床',
    et: '儿童',
    cr: '成人',
    cf: '出发',
    fc: '返程',
    qecqryxxx: '请二次确认以下信息',
    xcjs: '行程介绍',
    fybh: '费用包含',
    zfxm: '自费项目',
    tbtx: '特别提醒',
    fyxz: '费用细则',
    xzxc: '下载行程',
    wqts: '温馨提示',
    bjbz: '报价币种',
    xcwd: '行程文档',
    jhd: '集合地',
    rqxz: '人群限制',
    hyly: '华逸旅游',
    qglm: '全国联盟',
    tj: '推荐+',
    jrck: '进入查看',
    ljyd: '立即预定',
    cfrq: '出发日期',
    xt: '小童',
    zc: '占床',
    bzc: '不占床',
    ze: '总额',
    xtzc: '小童占床',
    xtbzc: '小童不占床',
    ksyd: '开始预订',
    ywzt: '游玩主题',
    zyx: '自由行',
    gty: '跟团游',
    bx: '不限',
    lx: '类型',
    mdd: '目的地',
    ss: '搜索',
    qsrmddjdgjz: '请输入目的地、景点、关键词、或参考团号',
    cfd: '出发地',
    drbc: '单人补差',
    sfz: '身份证',
    hz: '护照',
    gahxz: '港澳回乡证',
    tbz: '台胞证',
    qt: '其他',
    ts: '天数',
    hcrq: '回程日期',
    ykzl: '游客资料',
    xs: '姓氏',
    qsrxs: '请输入姓氏',
    mz: '名字',
    qsrmz: '请输入名字',
    qsrdh: '请输入电话',
    qsryx: '请输入邮箱',
    qxzxb: '请选择性别',
    qsrcsrq: '请输入出生日期',
    qsrzj: '请输入证件',
    qxz: '请选择',
    dy: '电邮',
    qsryxdz: '请输入邮箱地址',
    qsrzqyx: '请输入正确邮箱地址',
    yyjsqryj: '用于接收确认邮件',
    dhhm: '电话号码',
    qsrdhhm: '请输入电话号码',
    qsrzqdhhm: '请输入正确电话号码',
    jyykhfw: '仅用于客户服务',
    xg: '香港852',
    am: '澳门853',
    dl: '大陆86',
    tsyq: '特殊要求',
    xuantian: '（选填）',
    tjcddbsnyydbty: '提交此订单即表示您已阅读并同意 huayitraveltd.com 之使用细则与私隐条款。',
    xybzhqr: '下一步：最后确认',
    fh: '返回',
    jgxq: '价格详情',
    hj: '合计',
    zxzf: '在线支付',
    xxzf: '线下支付'
  },
  ticket: {
    hj: '合计',
    z: '张',
    zdj: '最低价',
    xzsl: '选择数量',
    xz: '选择',
    qxxz: '取消选择',
    q: '起',
    ljgm: '立即购买',
    qxzcp: '请选择产品',
    dj: '数量/单价',
    cp: '产品',
    g: '个',
    xqjs: '详情介绍',
    ydts: '预定提示',
    zwcp: '暂无产品',
    xzfa: '选择方案',
    xzrq: '选择日期',
    hdfl: '活动分类',
    mpjd: '门票景点',
    mscj: '美食餐券',
    mbqy: '目标区域',
    gzd: '共找到',
    gjz: '关键字',
    jgfw: '价格范围',
    qd: '确定',
    ksqr: '快速确认',
    gzsjn: '工作时间内，3小时内确认订单。',
    ydrq: '预定日期',
    dz: '地址',
    xj: '小计',
    fhxg: '返回修改',
    ykxx: '游客信息',
    yk: '游客',
    xm: '姓名',
    qsrxm: '请输入正确姓名',
    sj: '手机',
    qsrsj: '请输入手机',
    ywm: '英文名',
    qsrywm: '请输入英文名',
    qsryx: '请输入邮箱',
    yx: '邮箱',
    zj: '证件',
    qsrzj: '请输入证件',
    qsremail: '请输入email',
    lldh: '联络电话',
    qsrlxdh: '请输入联络电话',
    xg: '香港852',
    am: '澳门853',
    dl: '大陆86',
    bz: '备注',
    cddyydty: '提交此订单即表示您已阅读并同意 huayitraveltd.com 之使用细则与私隐条款。',
    xyb: '下一步：最后确认',
    pjyjscbtbg: '票卷一经售出不退不改。请务必核实信息后再提交。',
    ydtx: '预定提醒',
    djrl: '低价日历',
    zwbj: '暂无报价',
    jgrl: '价格日历'
  },
  specialEvent: {
    dh: '电话',
    cz: '传真',
    kfsj: '开放时间',
    bz: '备注',
    sf: '收费',
    hdyf: '活动月份',
    dz: '地址',
    gjd: '个景点',
    macau: {
      am: '澳门',
      tsamszw: '探索澳门食住玩好去处',
      myswt: '民以食为天',
      myswtdesc: '想像当地人一样寻访地道美食？记得别错过这些最受观迎的澳门菜式及美食热点。',
      jwzbh: '今晚住边好',
      jwzbhdesc: '发掘澳门的最受欢迎住宿地点，以及其他旅客的推荐及特别酒店优惠。',
      ck: '查看',
      wlhqc: '玩乐好去处',
      wlhqcdesc: '想知澳门有什么推荐活动？由不容错过的景色，到当地人热爱的聚脚地，我们能为您提供一切所需的最新资讯。',
      ddhd: '当地活动',
      ddhddesc: '查看本地当月热门活动。',
      hdrq: '活动日期'
    },
    package: {
      zs: '住宿',
      mp: '门票'
    },
    oloq: {
      ozxhtdesc: '8条欧洲旅游路线，每周循环，畅游22个国家75座城市！欧洲当地参团，随上随下，全年保证出发！',
      ozxht: '欧来欧去循环式旅行团',
      oloqtdesc: '2005年始发，至今从不间断，每年超过200,000人次参加！',
      oloqt: '欧来欧去循环式欧洲旅行团路线图'
    },
    chimelong: {
      gzcl: '广州长隆',
      zhcl: '珠海长隆',
      jd: '当季热销·酒店',
      mp: '当季热销·门票'
    },
    disney: {
      ljqwyd: '立即前往预定',
      hxdesc: '乘坐极速矿车，飞越灰熊山谷，在轨道纵横交错的矿洞内穿梭飞驰。矿车会带你来回穿梭整个山谷，享受从山顶倒行急坠的快感，畅游传说中的寻金小镇。',
      hx: '灰熊山极速矿车',
      szdesc: '狮子王辛巴、丁满和彭彭跳出大银幕，成为大型歌舞剧的主角，配合连串精彩的杂技和火舞表演，带你体验丛林的乐趣！',
      sz: '狮子王庆典',
      mfswdesc: '“迪士尼魔法书房”揉合迪士尼经典与新一代故事在华丽大舞台上精彩上演，呈献数不尽的Happily Ever After感动时刻！',
      mfsw: '迪士尼魔法书房',
      tjqxDesc: '超级英雄，震撼登陆！踏入“史达工业”的未来科技世界，见证最新的科技钜献，更可戴上“史达前瞻智能眼镜”，与“铁甲奇侠”飞越香港上空，并一同对抗邪恶势力“九头蛇”！',
      tjqx: '“铁甲奇侠飞行之旅” ─ 由友邦呈献',
      hgndesc: '一起来坐上经典的旋转木马，化身成迪士尼动画《仙履奇缘》中的王子和公主，随着悠扬的音乐旋转、跳动。跃上华丽的旋转木马，在色彩缤纷的背景和悠扬的音乐中飞跃奔驰。',
      hgn: '灰姑娘旋转木马',
      xmgzldesc: '魔法般的立体光雕投影技术将贯穿整个汇演，多位迪士尼及彼思角色的投影更会现身塔楼，甚至从城堡腾飞至水幕喷泉之上。结合交织投射的激光与灯光、水柱、璀璨夺目的烟火效果、配合重新编制的迪士尼音乐与旋律，将不同角色的人生片段带到宾客眼前，与你回忆往昔、迈步向前，活出奇妙人生。',
      xmgzl: '迪士尼星梦光影之旅',
      ylbydesc: '乐园一连串令人无法抗拒的精彩活动，让你的迪士尼体验更加完满。',
      ylby: '切勿错过的游乐设施及娱乐表演',
      zwcxdfj: '暂无查询到房型',
      fj: '房间',
      cr: '成人',
      et: '儿童',
      qd: '确定',
      ets: '儿童数',
      crs: '成人数',
      fjs: '房间数',
      dsndmhqf: '迪士尼的梦幻气氛',
      zjdsnjdgs: '住进迪士尼的经典故事，演活属于您自己的故事。',
      ckxq: '查看详情',
      lyjd: '迪士尼乐园酒店',
      hlwjd: '迪士尼好莱坞酒店',
      dyweddjjd: '独一无二的度假酒店'
    }
  },
  user: {
    jmm: '旧密码',
    xmm: '新密码',
    bc: '保存',
    xm: '姓名',
    dzyj: '电子邮件',
    lxdh: '联系电话',
    dc: '导出',
    sjkx: '实际款项',
    fhkx: '反还款项',
    ykkx: '已扣款项',
    yxdd: '有效订单',
    qxdd: '取消订单',
    hjdd: '合计订单',
    ssxt: '所属系统',
    xdrq: '下单日期',
    syed: '使用额度',
    cpxx: '产品信息',
    ddbh: '订单编号',
    cx: '查询',
    js: '结束',
    ks: '开始',
    z: '至',
    rzrq: '入住日期',
    ldrq: '离店日期',
    yqx: '已取消',
    yzf: '已支付',
    wzf: '未支付',
    bx: '不限',
    ddzt: '订单状态',
    jd: '酒店',
    pw: '票务',
    ddlx: '订单类型',
    lvxm: '旅客姓名',
    syyck: '剩余预存款',
    syued: '剩余额度',
    am: '澳门',
    xg: '香港',
    lkbxg: '留空不修改',
    mm: '密码',
    qsrdh: '请输入电话',
    dh: '电话',
    qsryhm: '请输入用户名',
    yhm: '用户名',
    qsrxm: '请输入姓名',
    xiugai: '修改',
    qy: '启用',
    jy: '禁用',
    cz: '操作',
    zc: '正常',
    ty: '停用',
    zt: '状态',
    yj: '邮件',
    dlzh: '登录账号',
    tj: '添加',
    qsrmm: '请输入密码',
    jianshu: '间数',
    ddje: '订单金额',
    bzxx: '备注信息',
    dzf: '待支付',
    zkxx: '住客信息',
    qrh: '确认号',
    lldh: '联络电话',
    llyx: '联络邮箱',
    ykxx: '游客信息',
    qt: '其他',
    tbz: '台胞证',
    gahxz: '港澳回乡证',
    hz: '护照',
    sfz: '身份证',
    yx: '邮箱',
    sj: '手机',
    zj: '证件',
    csrq: '出生日期',
    xb: '性别',
    rs: '人数',
    cfrq: '出发日期',
    zcyd: '再次预定',
    fk: '付款',
    ksxz: '客人信息',
    j: '间',
    w: '晚',
    ywrq: '游玩日期',
    krxx: '客人信息',
    cxrq: '出行日期',
    ydrq: '预定日期',
    hy: '会员',
    hzhb: '合作伙伴',
    ddlb: '订单列表',
    qb: '全部',
    xl: '线路',
    grzl: '个人资料',
    zhjmm: '账户及密码',
    zzh: '子账号',
    zh: '账户',
    cwxx: '财务信息',
    edxx: '额度信息',
    zcsrmm: '再次输入密码',
    mmbnwk: '密码不能为空',
    dqsxfwwdd: '当前筛选范围内暂无订单，',
    ljqw: '立即前往',
    ydj: '预定。',
    ss: '搜索',
    lcsrmmbyz: '两次输入密码不一致'
  },
  pay: {
    PaymentList: {
      mpay: 'MPay',
      wechat: '微信支付',
      alipay: '支付宝',
      offline: '线下支付',
      quota: '额度支付',
      MPayDesc: '推荐 MPay 用户优先选优，支付币种MOP',
      wechatDesc: '推荐 内地 用户优先选优，支付币种CNY',
      alipayDesc: '推荐 内地 用户优先选优，支付币种CNY',
      offlineDesc: '香港 或 同行用户可通过线下转账形式进行支付',
      quotaDesc: '同行额度支付'
    },
    qy: '请于',
    nzfdd: '内支付订单',
    fkfs: '付款方式',
    ljzf: '立即支付',
    fksb: '付款失败',
    fkcg: '付款成功',
    zfcg: '支付成功，返回首页',
    zfsb: '支付失败,返回产品',
    ddbh: '订单编号',
    xszf: '线上支付',
    rz: '入住',
    ld: '离店',
    js: '间数',
    ywrq: '游玩日期',
    sl: '数量',
    cpmc: '产品名称',
    cxrq: '出行日期',
    bstk: '不设退款',
    ddqrhbkqxhgg: '订单确认后不可取消或更改。若您有效期内没有使用，将收取全额费用 。',
    hztvjbgxaqfsw: 'huayitraveltd.com将把阁下安全放在首位，本站点已通过以下机构安全验证：'
  },
  // 星期几翻译 - 移到根级别
  sunday: '周日',
  monday: '周一',
  tuesday: '周二',
  wednesday: '周三',
  thursday: '周四',
  friday: '周五',
  saturday: '周六'
}



// WEBPACK FOOTER //
// ./src/lang/zhCN.js